import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Category } from '../models/Category';
import { Pagination } from '../models/Pagination';
import { ServerResponse } from '../models/ServerResponse';
import { QueryBuilderService } from './query-builder.service';

@Injectable({
	providedIn: 'root'
})
export class CategoryService {

	readonly API_CATEGORY_ROUTE : string;

	constructor(private http:HttpClient,
				private queryBuilder:QueryBuilderService) {
		this.API_CATEGORY_ROUTE = environment.API_URL + "/category";
	}

	public getAll() : Observable<Category[]> {
		let route = this.API_CATEGORY_ROUTE + "/list";
		let qo = this.queryBuilder.default();

		return this.http.post<ServerResponse<Pagination<Category>>>(route, qo).pipe(
			map((sr:ServerResponse<Pagination<Category>>)=> {
				return sr.response!.data;
			})
		);
	}

	list() : Observable<Category[]> {
		let route = environment.API_URL + "/store/list-category-rating";
		
		return this.http.get<ServerResponse<Category[]>>(route).pipe(
			map((sr:ServerResponse<Category[]>)=> {
				return sr.response!;
			})
		);
	}
}